module.exports = __webpack_public_path__ + "static/media/farms.51abad45.jpg";